import { render, staticRenderFns } from "./PickingIndex.vue?vue&type=template&id=63ccda0a&scoped=true&"
import script from "./PickingIndex.vue?vue&type=script&lang=js&"
export * from "./PickingIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ccda0a",
  null
  
)

export default component.exports